"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useTransition } from "react";
import { toast } from "sonner";
import { logout } from "@/lib/auth/actions";
import { completeAuthTransition } from "@/lib/auth/client-transition";
export function useLogout() {
  const $ = _c(3);
  const [isLoggingOut, startTransition] = useTransition();
  const isInFlightRef = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isInFlightRef.current) {
        return;
      }
      isInFlightRef.current = true;
      startTransition(async () => {
        ;
        try {
          const result = await logout();
          if ("error" in result) {
            isInFlightRef.current = false;
            toast.error(result.error);
            return;
          }
          completeAuthTransition(result);
        } catch (t1) {
          const error = t1;
          isInFlightRef.current = false;
          toast.error(error instanceof Error ? error.message : "Unable to sign out. Please try again.");
        }
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const startLogout = t0;
  let t1;
  if ($[1] !== isLoggingOut) {
    t1 = {
      isLoggingOut,
      startLogout
    };
    $[1] = isLoggingOut;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}